import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import GroupService from 'services/GroupService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    groupData: [],
    singleGroup:[],
    groupNote: [],
    groupPlayer: [],
    groupSession: [],
    resData:[],
    allCoachData:[],
    allClubData:[],
}


export const getGroup = createAsyncThunk('group/getGroup', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getGroup(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const getGroupWithId = createAsyncThunk('group/getGroupWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getGroupWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getGroupNote = createAsyncThunk('group/getGroupNote', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getGroupNote(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getGroupPlayer = createAsyncThunk('group/getGroupPlayer', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getGroupPlayer(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getGroupSession = createAsyncThunk('group/getGroupSession', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getGroupSession(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const createGroup = createAsyncThunk('coach/createGroup', async (data, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.createGroup(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getAllCoach = createAsyncThunk('coach/getAllCoach', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getAllCoach(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getAllClub = createAsyncThunk('group/getAllClub', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.getAllClub(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const updateGroup = createAsyncThunk('group/updateGroup', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.updateGroup(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const reActivateGroup = createAsyncThunk('group/reActivateGroup', async (params, { rejectWithValue }) => {
	
	try {
		const response = await GroupService.reActivateGroup(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const groupSlice = createSlice({
    name: 'group',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getGroup.pending, (state) => {
            state.loading = true
        })
        .addCase(getGroup.fulfilled, (state, action) => {
            state.loading = false
            state.groupData = action.payload
        })
        .addCase(getGroup.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
        .addCase(getGroupWithId.pending, (state) => {
            state.loading = true
            state.resData = []
        })
        .addCase(getGroupWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singleGroup = action.payload
        })
        .addCase(getGroupWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getGroupNote.pending, (state) => {
            state.loading = true
        })
        .addCase(getGroupNote.fulfilled, (state, action) => {
            state.loading = false
            state.groupNote = action.payload
        })
        .addCase(getGroupNote.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getGroupPlayer.pending, (state) => {
            state.loading = true
        })
        .addCase(getGroupPlayer.fulfilled, (state, action) => {
            state.loading = false
            state.groupPlayer = action.payload
        })
        .addCase(getGroupPlayer.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getGroupSession.pending, (state) => {
            state.loading = true
        })
        .addCase(getGroupSession.fulfilled, (state, action) => {
            state.loading = false
            state.groupSession = action.payload
        })
        .addCase(getGroupSession.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(createGroup.pending, (state) => {
            state.loading = true
            state.message=''
        })
        .addCase(createGroup.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Group Added"
        })
        .addCase(createGroup.rejected, (state, action) => {
           // state.message = action.message
           // state.showMessage = true
            state.loading = false
        })
        .addCase(getAllCoach.pending, (state) => {
            state.loading = true
        })
        .addCase(getAllCoach.fulfilled, (state, action) => {
            state.loading = false
            state.allCoachData = action.payload
        })
        .addCase(getAllCoach.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getAllClub.pending, (state) => {
            state.loading = true
        })
        .addCase(getAllClub.fulfilled, (state, action) => {
            state.loading = false
            state.allClubData = action.payload
        })
        .addCase(getAllClub.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(updateGroup.pending, (state) => {
            state.loading = true
            state.message=''
        })
        .addCase(updateGroup.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Group Updated"
        })
        .addCase(updateGroup.rejected, (state, action) => {
           // state.message = action.message
           // state.showMessage = true
            state.loading = false
        })
        .addCase(reActivateGroup.pending, (state) => {
            state.loading = true
            state.message=''
        })
        .addCase(reActivateGroup.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Group Activated"
        })
        .addCase(reActivateGroup.rejected, (state, action) => {
           // state.message = action.message
           // state.showMessage = true
            state.loading = false
        })
       
    }
});


export default groupSlice.reducer;